import { CoachActivityTypeEnum } from "@/modules/coach/coachActivityTypes"
import { HUImageDtoSchema } from "@/modules/dtos/imageDto"
import { PhoneNumberWithPrefixSchema } from "@modules/box/boxTypes"
import { z } from "zod"

export const ProfessionalActivityTypeDtoSchema = z.object({
  id: z.string().nullable(),
  orderIndex: z.number(),
  type: z.enum(CoachActivityTypeEnum),
  otherType: z.string().nullable(),
  principal: z.boolean(),
  creationDate: z.string().nullable(),
  archived: z.boolean(),
  archivedDate: z.string().nullable(),
})
export type ProfessionalActivityTypeDto = z.infer<typeof ProfessionalActivityTypeDtoSchema>

export const ProfessionalAdditionalInformationDtoSchema = z.object({
  id: z.string().nullable(),
  orderIndex: z.number(),
  information: z.string(),
  creationDate: z.string().nullable(),
  archived: z.boolean(),
  archivedDate: z.string().nullable(),
})
export type ProfessionalAdditionalInformationDto = z.infer<typeof ProfessionalAdditionalInformationDtoSchema>

export const ProfessionalProfileDtoSchema = z.object({
  id: z.string(),
  role: z.string().nullable(),
  firstname: z.string().nullable(),
  lastname: z.string().nullable(),
  commercialName: z.string().nullable(),
  yearsOfExperience: z.number().nullable(),
  email: z.string().nullable(),
  phoneNumber: PhoneNumberWithPrefixSchema.nullable(),
  description: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  country: z.string().nullable(),
  imageKey: HUImageDtoSchema.nullable(),
  activityTypes: z.array(ProfessionalActivityTypeDtoSchema).nullable(),
  training: z.string().nullable(),
  imageKeys: z.array(HUImageDtoSchema).nullable(),
  additionalInformation: z.array(ProfessionalAdditionalInformationDtoSchema).nullable(),
  archived: z.boolean(),
  archivedDate: z.string().nullable(),
  creationDate: z.string().nullable(),
})
export type ProfessionalProfileDto = z.infer<typeof ProfessionalProfileDtoSchema>

export const ProfessionalProfileInputDtoSchema = z.object({
  role: z.string().nullable(),
  firstname: z.string().nullable(),
  lastname: z.string().nullable(),
  commercialName: z.string().nullable(),
  yearsOfExperience: z.number().int().nullable(),
  email: z.string(),
  phoneNumber: PhoneNumberWithPrefixSchema.nullable(),
  description: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  country: z.string(),
  imageKey: z.string(),
  activityTypes: z.array(ProfessionalActivityTypeDtoSchema),
  training: z.string().nullable(),
  imageKeys: z.array(z.string()).nullable(),
  additionalInformation: z.array(ProfessionalAdditionalInformationDtoSchema),
})
export type ProfessionalProfileInputDto = z.infer<typeof ProfessionalProfileInputDtoSchema>

export const ProfessionalProfileUpdateDtoSchema = z.object({
  role: z.string().nullable(),
  firstname: z.string().nullable(),
  lastname: z.string().nullable(),
  commercialName: z.string().nullable(),
  yearsOfExperience: z.number().nullable(),
  email: z.string().nullable(),
  phoneNumber: PhoneNumberWithPrefixSchema.nullable(),
  description: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  country: z.string().nullable(),
  imageKey: z.string().nullable(),
  activityTypes: z.array(ProfessionalActivityTypeDtoSchema),
  training: z.string().nullable(),
  imageKeys: z.array(z.string()).nullable(),
  additionalInformation: z.array(ProfessionalAdditionalInformationDtoSchema),
})
export type ProfessionalProfileUpdateDto = z.infer<typeof ProfessionalProfileUpdateDtoSchema>
